<ul class="navbar-nav d-flex align-items-center flex-row">
  <li class="lh-1">
    <a
      class="account-button nav-link link-light px-2"
      role="button"
      placement="bottom-end"
      (click)="openMenuOrNavigate()"
      data-automation-id="mobile-login-button"
    >
      <digital-platform-icon
        icon="user-outline"
        color="white"
        [height]="20"
        [width]="20"
        [class.navbar-nav__my-account]="!identityService.isLoggedIn"
        data-automation-id="meganav-mobile-account-open-close-button"
      ></digital-platform-icon>
      <span
        *ngIf="identityService.isLoggedIn"
        class="chevron-icon"
        [class.chevron-icon--rotate]="accountDropdownOpened"
      ></span>
    </a>
  </li>
  <li class="lh-1">
    <button
      (click)="onToggle()"
      class="navbar-nav__hamburger-menu"
      [class.navbar-nav__hamburger-menu--active]="mobileNavOpen"
      data-automation-id="meganav-mobile-open-close-button"
    ></button>
  </li>
</ul>
